import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { Angulartics2Module } from 'angulartics2';
import {
  NgbDatepickerModule,
  NgbAlertModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';

import {
  PipesModule,
  SearchBarModule,
  SharedTabsModule,
  UtilsModule,
  LoaderModule,
  SwitcherModule,
} from '@tablesready/common-ui';
import { FullCalendarModule } from '@fullcalendar/angular';
import { FrontendTimelineModule } from '@tablesready/frontend-timeline';
import { CanvasModule } from '@tablesready/canvas';
import { BadgeModule } from '@tablesready/frontend-badge';
import { FrontendCountdownTimerModule } from '@tablesready/frontend-countdown-timer';
import { FloorPlanRoutingModule } from './floorplan-routing.module';
import { FloorplanComponent } from './floorplan.component';
import {
  FloorplanCardComponent,
  FloorplanViewComponent,
  TableInfoComponent,
  DayGridViewComponent,
  DetailPartyComponent,
} from './components';
import { TableTimeComponent } from './components/table-time/table-time.component';
import { WaitlistAddEditPartyModule, WaitlistNotifyModule } from '../components';
import { IonicModule } from '@ionic/angular';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { FrontendHeaderModule } from '@tablesready/frontend-header';
import { FrontendDropdownModule } from '@tablesready/frontend-dropdown';

@NgModule({
  declarations: [
    FloorplanViewComponent,
    FloorplanCardComponent,
    TableInfoComponent,
    FloorplanComponent,
    TableTimeComponent,
    DayGridViewComponent,
    DetailPartyComponent,
  ],
  imports: [
    WaitlistAddEditPartyModule,
    FloorPlanRoutingModule,
    CommonModule,
    CanvasModule,
    FrontendIconsModule,
    FormsModule,
    NgbDatepickerModule,
    SearchBarModule,
    SharedTabsModule,
    PipesModule,
    NgbAlertModule,
    UtilsModule,
    NgbTooltipModule,
    LoaderModule,
    SwitcherModule,
    Angulartics2Module,
    WaitlistNotifyModule,
    FullCalendarModule,
    BadgeModule,
    FrontendTimelineModule,
    FrontendCountdownTimerModule,
    IonicModule,
    FrontendHeaderModule,
    FrontendDropdownModule,
  ],
})
export class FloorplanModule { }
